module.exports = __webpack_public_path__ + "img/baogarnelen.2c588b87.jpg";